import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { Checkbox } from 'semantic-ui-react';

import Spinner from "../../ui/Spinner/Spinner";
import AnswerItem from "./AnswerItem/AnswerItem";
import RequireAuth from "../../layout/HOC/require-auth";
import "./PollInfo.scss";

import { getPollInfoAsync, changePollVisibilityAsync } from "../../../redux/actions/pollInfo";

const mapStateToProps = state => ({
  ...state.pollInfo,
});

const mapDispatchToProps = dispatch => ({
  onGoBack: () => dispatch(push('/polls')),
  getPollInfo: pollId => dispatch(getPollInfoAsync(pollId)),
  onEditPoll: pollId => dispatch(push(`/edit-poll/${pollId}`)),
  onChangePollVisibility: (status, pollId) => dispatch(changePollVisibilityAsync(status, pollId)),
});

class PollInfo extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    poll: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    onEditPoll: PropTypes.func.isRequired,
    getPollInfo: PropTypes.func.isRequired,
    onChangePollVisibility: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { getPollInfo } = this.props;
    const pollId= this.props.match.params.pollId;
    getPollInfo(pollId);
  }

  renderAnswers = (answer, i) => {
    return(
      <AnswerItem
        key={`${answer.id}_${i}`}
        item={answer}
        index={i}
      />
    );
  }

  addMax = (item, i) => {

  }

  render() {
    const { ready, loading, poll, onGoBack, onEditPoll, onChangePollVisibility } = this.props;

    return (
      <div className="page-wrapper">
        {ready ? (
          <React.Fragment>
            <div className="page-header">
              <button type="button" className="btn btn-back" onClick={() => onGoBack()}>
                <i aria-hidden="true" className="back-icon icon" />
                <span>Назад</span>
              </button>
            </div>
          
            <div className="page-content forms">
              <div className="poll-header">
                <div className="poll-btns">
                  <button
                    type="button"
                    className="btn btn-green edit-size"
                    onClick={() => onEditPoll(poll.id)}
                  >
                    Редактировать
                  </button>
                </div>
                {/* СКРЫТИЕ ШАБЛОНА */}
                {/* Поскольку просмотреть можно только видимый шаблон, всегда передаем статус DISABLED */}
                <div className="checkboxes-wrap">
                  <Checkbox
                    label='Скрывать шаблон'
                    checked={!poll.isVisible} 
                    onChange={() => onChangePollVisibility('DISABLED', poll.id)}
                  />
                </div>
              </div>
              <div className="title-wrap">
                <h1 className="page-title">{poll.text}</h1>
              </div>
              {poll.answers.length !== 0 ? (
                <div className="answers-wrap">
                  {poll.answers.map(this.renderAnswers)}
                </div>
              ) : false}
              <div className="content-info">
                <div className="votes-total">Всего голосов: {poll.vote_count}</div>
                {(poll.type === 'CONSULTANTS') || (poll.type === 'ALL') ? 
                  (<div className="content-for consultants">Для консультантов</div>)
                : false}
                {(poll.type === 'CLIENTS') || (poll.type === 'ALL') ? 
                  (<div className="content-for clients">Для клиентов</div>)
                : false}
              </div>
            </div>
          </React.Fragment>
        ) : false}
        {loading ? (<Spinner />) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(PollInfo));
